import React from 'react';
import PropTypes from 'prop-types';

// 작성한 항목을 한눈에 보고 원하는 항목으로 돌아가는 전체 보기.
export default function CaseOverview({ fields, values, onEdit }) {
    return <div className="case-overview">
        <h3>작성한 사례개념화 전체 보기</h3>
        <p className="ai-small">항목끼리 이어지는지 확인하고, 고칠 항목은 수정을 눌러 돌아가세요.</p>
        {fields.map(field => <section key={field.key} className="case-overview-item">
            <div className="review-row">
                <h4>{field.label}{field.required && <span className="case-required" aria-hidden="true"> *</span>}</h4>
                <button type="button" className="review-secondary case-small-button" onClick={() => onEdit(field.key)} aria-label={`${field.label} 수정`}>수정</button>
            </div>
            {values[field.key].trim() ? <p>{values[field.key]}</p> : <p className="ai-small">{field.required ? '필수 항목이지만 아직 작성하지 않았습니다.' : '아직 작성하지 않았습니다.'}</p>}
        </section>)}
    </div>;
}

CaseOverview.propTypes = {
    fields: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string.isRequired, label: PropTypes.string.isRequired, required: PropTypes.bool })).isRequired,
    values: PropTypes.objectOf(PropTypes.string).isRequired,
    onEdit: PropTypes.func.isRequired,
};
